import { useEffect, useState, useContext } from "react";
import { langContext } from "commons/contexts";

import { useRouteMatch } from "react-router-dom";

import style from "./style.module.scss";

import "./news.css";
import textNl from "../newsText/nl";
import textFr from "../newsText/fr";

const texts:Record<string,Record<string,Record<string,string>>> = {
    nl: textNl,
    fr: textFr
}

function News() {
    const { params } = useRouteMatch<Record<string,string>>();
    const newsPage = params?.news;

    const { lang } = useContext(langContext);


    // let pathString = location.pathname || "";
    // if (pathString.length !== 0) pathString = pathString.substr(Math.max(pathString.lastIndexOf("/"), 0) + 1);
    // const newsPage = pathString;

    const [text, setText] = useState<Record<string,string>>((texts[lang][newsPage]) || {});


    useEffect(() => {
        setText(texts[lang][newsPage]);
    //eslint-disable-next-line
    }, [lang]);


    return (
        <div className={style.newsRoot}>
            <div className={style.newsContainer}>
                {/* <div className={style.date}>{data?.date}</div> */}
                <div className={style.title}>{text?.title}</div>

                {text?.image &&
                    <>
                        <img src={text?.image} alt="news" />
                        <br />
                        <br />
                    </>
                }
                <div dangerouslySetInnerHTML={{ __html: text?.text }}>

                </div>
                <br />
                <br />
            </div>
        </div>
    );
}

export default News;